<hr />
@if (minimumQuantitySurcharge?.showLowTradingHint) {
  <div
    data-zid="low-trading-hint"
    [attr.data-minimum-quantity-surcharge-value]="minimumQuantitySurcharge.value"
    class="border p-3"
    [innerHTML]="
      'trade.confirm.button.lowtrading'
        | transloco
          : {
              lowTradingThreshold: minimumQuantitySurcharge.threshold,
              minQuantitySurcharge: minimumQuantitySurcharge.value,
            }
    "
  ></div>
}
<div class="row">
  <div class="col-12 mt-2">
    <web-components-user-messages />
  </div>
</div>

<div class="row mb-3">
  @if (minimumQuantitySurcharge?.showLowTradingHint && minimumQuantitySurcharge.value) {
    <div class="col-12 mt-4">
      <web-design-system-button
        type="primary"
        size="large"
        [fullwidth]="true"
        data-zid="confirm"
        (click)="confirmLowTradingAndPlaceOrder.emit()"
      >
        {{ 'trade.confirm.button.confirm-lowtrading' | transloco | uppercase }}
      </web-design-system-button>
    </div>
  } @else {
    <div class="col-12 mt-3">
      <web-design-system-button
        type="primary"
        size="large"
        [fullwidth]="true"
        data-zid="confirm"
        (click)="placeOrder.emit()"
        [disabled]="disabled"
      >
        <span class="hidden-xs">
          {{ 'trade.confirm.button.confirm' | transloco | uppercase }}
        </span>
        <span class="hidden-sm hidden-md hidden-lg hidden-xl">
          {{ 'trade.confirm.button.confirm-xs' | transloco | uppercase }}
        </span>
      </web-design-system-button>
    </div>
  }
  <trade-donau-capital-hint class="d-block col-12" />
</div>
